<template>
    <div v-if="Object.keys(model).length !== 0" class="wrapper">
        <item-form
            :model="model"
            :isEditing="true"
            @save-item="updateItem"
            @create-schema="createSchema"
            @open-form-import="openFormImport">
        </item-form>

        <b-modal title="Wijzigen" size="sm" class="modal-danger" v-model="warningModal" @ok="closedialog">
            FOUT: Klassiek belichtingsschema werd niet gewijzigd! {{errormsg}}
        </b-modal>

        <b-modal title="Belichtingsschema creëren" size="sm" class="modal-primary" v-model="warningGeduld">
            <div slot="modal-footer" class="w-100"><p>Even geduld a.u.b.</p></div>
            <p><fadeloader :loading="loading" :size="size" :color="color" class="spinner"></fadeloader></p>
            <p>&nbsp;<br/>&nbsp;</p>
            <p>Klassiek belichtingsschema wordt gecreëerd. Deze bewerking kan even duren.</p>
        </b-modal>

        <b-modal title="Belichtingsschema importeren" size="lg" class="modal-primary" v-model="vraagBestand" :no-close-on-backdrop="true">
            <div slot="modal-footer" class="w-100">
                <p>
                    <b-button @click="closeFormImport(model)" variant="secondary">Annuleren</b-button>
                    <b-button @click="doImport(model)" variant="primary">OK</b-button>
                </p>
            </div>
            <p><strong>Let op! Bestaande data in het belichtingsschema worden overschreven!</strong></p>

            <p>
            <div class="form-group">
                <label class="col-form-label" for="fileToUpload">Csv-bestand</label>
                <b-form-file accept=".csv" ref="file-input" id="fileToUpload" name="fileToUpload" v-model="model.fileToUpload" :plain="true"></b-form-file>
                <span class="small text-danger" v-show="foutbestand">Kies een csv-bestand</span>
            </div>
            </p>

        </b-modal>

        <b-modal title="Belichtingsschema importeren" size="sm" class="modal-primary" v-model="warningGeduldImport">
            <div slot="modal-footer" class="w-100"><p>Even geduld a.u.b.</p></div>
            <p><fadeloader :loading="loading" :size="size" :color="color" class="spinner"></fadeloader></p>
            <p>&nbsp;<br/>&nbsp;</p>
            <p>Het belichtingsschema wordt geïmporteerd. Deze bewerking kan even duren.</p>
        </b-modal>

        <b-modal title="Belichtingsschema importeren" size="sm" class="modal-danger" v-model="errorImport" @ok="closedialog">
            FOUT: Belichtingsschema werd niet geïmporteerd! Controleer de structuur van het csv-bestand. {{errormsg}}
        </b-modal>

        <b-modal title="Belichtingsschema creëren" size="sm" class="modal-danger" v-model="warningSchema" @ok="closedialog">
            FOUT: Klassiek belichtingsschema werd niet gecreëerd! {{errormsg}}
        </b-modal>
    </div>
    <div v-else class="midden">
        <div style="color: #20a8d8; font-size: large;">Even geduld a.u.b.</div>
        <fadeloader :loading="loading" :size="size" :color="color" class="spinner2"></fadeloader>
    </div>
</template>

<script>
    // https://github.com/greyby/vue-spinner
    import FadeLoader from 'vue-spinner/src/FadeLoader';
    import api from '../../api/afdelingteelt';
    import ItemForm from './FormKlassiek';

    export default {
        data () {
            return {
                warningModal: false,
                warningSchema: false,
                warningGeduld: false,
                warningGeduldImport: false,

                vraagBevestiging: false,
                vraagBestand: false,
                errorImport: false,

                foutbestand: false,
                errormsg: '',
                model: { },

                loading: true,
                size: '20px',
                color: '#20a8d8',
            };
        },
        created () {
            this.getSchema(this.$route.params.id);
        },
        methods: {
            getSchema (id) {
                api.getKlassiekebelichting(id).then((response) => {
                    this.model = response.data.model;
                });
            },
            createSchema (model) {
                this.warningGeduld = true;
                api.createKlassiekebelichting(model).then(() => {
                    this.warningGeduld = false;
                    this.getSchema(model.id);
                },
                (error) => {
                    this.warningGeduld = false;
                    this.errormsg = error.message;
                    this.warningSchema = true;
                });
            },
            updateItem (model) {
                api.updateKlassiekebelichting(model).then(() => {
                    this.$router.replace('/beheer/afdelingteelt');
                },
                (error) => {
                    this.errormsg = error.message;
                    this.warningModal = true;
                });
            },
            closedialog () {
                this.warningModal = false;
                this.warningSchema = false;
            },
            openFormImport (model) {
                // this.model.fileToUpload = new File([""], "filename");
                this.$refs['file-input'].reset();
                this.foutbestand = false;
                this.vraagBestand = true;
            },
            closeFormImport (model) {
                this.vraagBestand = false;
            },
            doImport (model, event) {
                if (this.model.fileToUpload == undefined) {
                    this.foutbestand = true;
                } else {
                    this.foutbestand = false;
                    this.vraagBestand = false;
                    this.warningGeduldImport = true;

                    let formData = new FormData();
                    formData.append('fileToUpload', this.model.fileToUpload);
                    formData.append('id', this.model.id);
                    api.importBelichtingsschema(formData).then(() => {
                            this.warningGeduldImport = false;
                            this.getSchema(model.id);
                        },
                        (error) => {
                            this.warningGeduldImport = false;
                            this.errormsg = error.message;
                            this.errorImport = true;
                        });
                }
            },
        },
        components: {
            'item-form': ItemForm,
            fadeloader: FadeLoader,
        },
    };
</script>

<style>

    .spinner {
        margin-top: 30px;
        margin-bottom: 20px;
        margin-left:130px;
        color: #20a8d8;
    }

    .spinner2 {
        margin-top: 30px;
        margin-left:75px;
        color: #20a8d8;
    }

    .midden {
        width: 150px;
        height: 100px;

        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;

        margin: auto;
    }

</style>



// WEBPACK FOOTER //
// src/pages/licht/EditKlassiek.vue